import styles from './AcfArtDirectionImage.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import Link from 'next/link';
import { Image } from '@/components';

let cx = className.bind(styles);

export default function AcfArtDirectionImage(props) {
	const { artDirectionImage, attributes } = props;
	const className = attributes.className?.split(' ') || [];

	let height, width, mobileHeight, mobileWidth;
	if (artDirectionImage.width) {
		const aspectRatio = artDirectionImage.image.node.mediaDetails.height / artDirectionImage.image.node.mediaDetails.width;
		width = artDirectionImage.width;
		height = width * aspectRatio;
	}
	if (artDirectionImage.mobileWidth) {
		const aspectRatio = artDirectionImage.mobileImage.node.mediaDetails.height / artDirectionImage.mobileImage.node.mediaDetails.width;
		mobileWidth = artDirectionImage.mobileWidth;
		mobileHeight = mobileWidth * aspectRatio;
	}

	function RenderImage() {
		return (
			<div id={attributes.anchor} className={cx(['ns_art-direction-image', 'art-direction-image', ...className, artDirectionImage.rounded && 'is-style-rounded', artDirectionImage.hideDesktop && 'hide-image--desk', artDirectionImage.hideMobile && 'hide-image--mobile'])}>
				{artDirectionImage.image && <Image className={cx([artDirectionImage.mobileImage && 'art-direction-image--desk', attributes.alignImage && `align-${attributes.alignImage}`])} image={artDirectionImage.image} alt={artDirectionImage.alternativeText} loading={attributes.imageLoading} width={width} height={height} />}
				{artDirectionImage.mobileImage && <Image className={cx(['art-direction-image--mobile', attributes.alignImage && `align-${attributes.alignImage}`])} image={artDirectionImage.mobileImage} alt={artDirectionImage.alternativeText} loading={attributes.imageLoading} width={mobileWidth} height={mobileHeight} />}
			</div>
		);
	}

	return artDirectionImage.link ? (
		<Link href={artDirectionImage.link.url} target={artDirectionImage.link.target} rel={artDirectionImage.link.target === '_blank' ? 'roreferrer noopener' : null} title={artDirectionImage.link.title}>
			<RenderImage />
		</Link>
	) : (
		<RenderImage />
	);
}

AcfArtDirectionImage.fragments = {
	key: `AcfArtDirectionImageFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfArtDirectionImageFragment on AcfArtDirectionImage {
			attributes {
				anchor
				alignImage: align
				className
			}
			artDirectionImage {
				alternativeText
				hideDesktop
				hideMobile
				image {
					...ImageFragment
				}
				link {
					target
					url
					title
				}
				mobileImage {
					...ImageFragment
				}
				mobileWidth
				rounded
				width
			}
		}
	`,
};

AcfArtDirectionImage.config = {
	name: 'AcfArtDirectionImage',
};
AcfArtDirectionImage.displayName = 'AcfArtDirectionImage';
